var RoundNode = require("../RoundNode");

module.exports = (function () {

	var o = function (graph) {
		RoundNode.apply(this, arguments);

		this.type("owl:NamedIndividual");
	};
	o.prototype = Object.create(RoundNode.prototype);
	o.prototype.constructor = o;

	return o;
}());
